import {
  DecisionPageLayout,
  DecisionSection,
} from "@/components/DecisionPageLayout";
import {
  SpravatoSafetyBlock,
  SpravatoInternalLinks,
} from "@/components/SpravatoSafetyBlock";
const SpravatoTiredOfMedication = () => (
  <DecisionPageLayout
    seo={{
      title:
        "“I Don't Want to Be on More Medication” — SPRAVATO® | Neuro Wellness TMS Centers of America",
      description:
        "A reasonable position, honestly. Learn what's actually different about SPRAVATO® — not another pill, but a supervised, time-limited treatment for treatment-resistant depression.",
      canonical: "/spravato-tired-of-medication",
      keywords:
        "tired of medication, SPRAVATO, esketamine nasal spray, treatment-resistant depression, Coral Springs FL",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "MedicalWebPage",
        name: "I Don't Want to Be on More Medication — SPRAVATO®",
        about:
          "Understanding what's different about SPRAVATO® for people tired of daily medication.",
        provider: {
          "@id": "https://neurowellnesstms.com/#organization",
        },
      },
    }}
    badge="SPRAVATO® · Recognition"
    title="A reasonable position, honestly"
    subtitle="You've been on things that made you feel worse. Things that dulled you."
    ctaHeading="If you want to think it through with someone"
    ctaText="A consultation is a conversation, not a commitment. Bringing your reservations is useful — a good clinician wants to hear them. Schedule a free phone consultation or call (954) 827-9793."
  >
    <DecisionSection heading="A reasonable position, honestly">
      <p>
        You've been on things that made you feel worse. Things that dulled you.
        Things you had to taper off carefully because stopping was its own
        ordeal.
      </p>
      <p>
        Somewhere in there you decided you were done adding pills to the pile —
        and given the experience, that's not stubbornness. It's a conclusion
        drawn from evidence.
      </p>
      <p>
        So you've been managing without, or managing with less, and it's been
        hard, and you'd rather it be hard than go back to feeling chemically
        flattened.
      </p>
    </DecisionSection>

    <DecisionSection heading="Being straight with you">
      <p>
        SPRAVATO® is a medication. It's esketamine, a Schedule III controlled
        substance, and it carries a boxed warning covering sedation,
        dissociation, respiratory depression, abuse and misuse, and suicidal
        thoughts and behaviors. It can cause dependence with prolonged use.
      </p>
      <p>
        If your objection is to medication in general, this doesn't sidestep it,
        and anyone who tells you otherwise is selling.
      </p>
    </DecisionSection>

    <DecisionSection heading="What is actually different">
      <p>
        <strong>You don't take it home.</strong> Every dose is given at a
        certified center under supervision. There's no bottle in your cabinet.
      </p>
      <p>
        <strong>It's not daily.</strong> Sessions start twice weekly and taper.
        It doesn't run in the background of your life the way an oral
        antidepressant does.
      </p>
      <p>
        <strong>It works on a different system.</strong> Which is why it can
        reach people the standard mechanism hasn't.
      </p>
      <p>
        <strong>The effects are contained and time-limited.</strong> The
        sedation and dissociation happen during the session and resolve. You're
        monitored throughout. That's a different experience than side effects
        that follow you around all day for months.
      </p>
      <p>
        Whether any of that addresses your actual objection is yours to judge.
        But it's a genuinely different arrangement than another prescription.
      </p>
    </DecisionSection>

    <SpravatoInternalLinks />
    <SpravatoSafetyBlock />
  </DecisionPageLayout>
);
export default SpravatoTiredOfMedication;
